// FedEx shipping-plan options for the office dropdown.
//
// The keys MUST match the backend source of truth:
//   apps/baback-end/src/modules/carrier-preferences/dto/carrier-preferences-by-providers/fedex-plans.ts
// The office only sends the selected `fedexPlan` key; the backend maps it to the
// actual shipment-shaping fields (service type, packaging, incoterm, ETD, ...)
// and validates the key (@IsIn), so an unknown key is rejected server-side.

export const FEDEX_PLAN_OPTIONS = [
  {
    key: "ONE_RATE_ENVELOPE",
    labelKey: "carrier.fedexCsp.plan.oneRateEnvelope",
  },
  { key: "GROUND_PARCEL", labelKey: "carrier.fedexCsp.plan.groundParcel" },
  { key: "EXPRESS_PARCEL", labelKey: "carrier.fedexCsp.plan.expressParcel" },
  { key: "RETURN_ONE_RATE", labelKey: "carrier.fedexCsp.plan.returnOneRate" },
  { key: "INTL_ECONOMY_DAP", labelKey: "carrier.fedexCsp.plan.intlEconomyDap" },
  {
    key: "INTL_PRIORITY_DDP",
    labelKey: "carrier.fedexCsp.plan.intlPriorityDdp",
  },
] as const;

export const FEDEX_PLAN_DEFAULT = "ONE_RATE_ENVELOPE";
export const FEDEX_PLAN_CUSTOM = "CUSTOM";

// Preselect: use the stored plan when it's a known option, else the default.
// (Carriers registered before this feature have no `fedexPlan` → default.)
export function resolveInitialPlan(currentPlan?: string | null): string {
  return FEDEX_PLAN_OPTIONS.some((o) => o.key === currentPlan)
    ? (currentPlan as string)
    : FEDEX_PLAN_DEFAULT;
}
